import React, { useEffect, useState } from 'react';
import Style from './BlogPage.module.css';
import firstH1Element from '../../../../util/firstH1Element';
import extractTextFromHtml from '../../../../util/extractTextAndWrapInH3';
import { Skeleton } from '@mui/material';
import { LayoutSideNavigation, Page } from '../../../../components';
import TopbarContainer from '../../../TopbarContainer/TopbarContainer';
import BlogAllNewsMenu from '../../comps/BlogAllNewsMenu';
import { useHistory, useLocation } from 'react-router-dom';
import FooterContainer from '../../../FooterContainer/FooterContainer';
import { PiList } from 'react-icons/pi';
import LargText from '../../../../components/text/LargText';

export const SkeletonBlogPage = props => {
  return (
    <div style={{ margin: 0 }}>
      <Skeleton animation="wave" height={100} style={{ marginBottom: 0 }} />
      <Skeleton animation="wave" height={10} width="80%" />
      <Skeleton
        animation="wave"
        style={{ width: '100%', height: '500px', top: '-100px', margin: '0' }}
      />
      <Skeleton animation="wave" height={100} style={{ top: '-150px' }} />
      <Skeleton animation="wave" height={50} width="80%" style={{ top: '-100px' }} />
      <Skeleton animation="wave" height={40} width="75%" style={{ top: '-100px' }} />
      <Skeleton animation="wave" height={30} width="70%" style={{ top: '-100px' }} />
      <Skeleton animation="wave" height={20} width="65%" style={{ top: '-100px' }} />
    </div>
  );
};

const BlogPage = ({ PublishedStory, reqWasMaded }) => {
  console.log('PublishedStory:', JSON.stringify(PublishedStory));
  const content = PublishedStory.content;
  const firstH1Match = content?.match(/<h1[^>]*>[\s\S]*?<\/h1>/);

  const sanitizedContent = firstH1Match ? content?.replace(firstH1Match[0], '') : content;
  const finalSanitizedContent = sanitizedContent?.replace(
    /<h1[^>]*>[\s\S]*?<\/h1>|<select[^>]*>[\s\S]*?<\/select>|<textarea[^>]*>[\s\S]*?<\/textarea>/gi,
    ''
  );
  const { title } = PublishedStory || {};
  const history = useHistory();
  const location = useLocation();
  const [isActive, setIsActive] = useState(false);
  const handleTogleMenu = () => {
    setIsActive(!isActive);
  };

  useEffect(() => {
    const pathWithoutLang = location.pathname.replace(/^\/[a-z]{2}/, '');

    if (pathWithoutLang === '/blog') {
      history.push(`${location.pathname}/blog-data`);
    }
  }, [location, history]);
  return (
    <Page title={title}>
      <LayoutSideNavigation
        topbar={<TopbarContainer currentPage="blog" />}
        sideNav={
          <div className={Style.container}>
            <BlogAllNewsMenu isActive={isActive} handleTogleMenu={handleTogleMenu} />
            <div className={Style.container_BlogPortal}>
              <div className={Style.top_container_title_top}>
                <div onClick={handleTogleMenu} className={Style.close_button}>
                  <PiList />
                </div>
                <LargText text={'Blog'} />
              </div>
              <div className={Style.main_container_blog}>
                <div className={Style.container_blog}>
                  <div className={Style.container_blog_menu_and_page}>
                    {!reqWasMaded && <SkeletonBlogPage />}{' '}
                    <h1
                      className={Style.blog_title}
                      dangerouslySetInnerHTML={{ __html: title }}
                    ></h1>
                    <div
                      className={`${Style.imageStyle}`}
                      dangerouslySetInnerHTML={{ __html: finalSanitizedContent }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        footer={<FooterContainer />}
      ></LayoutSideNavigation>
    </Page>
  );
};
export default BlogPage;
